const Title = () => {
	return (
		<>
			<h1>Expense Tracker</h1>
		</>
	)
}


export default Title;